import { render, staticRenderFns } from "./devswitch.vue?vue&type=template&id=30b225f5&"
import script from "./devswitch.vue?vue&type=script&lang=js&"
export * from "./devswitch.vue?vue&type=script&lang=js&"
import style0 from "./devswitch.vue?vue&type=style&index=0&id=30b225f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports